import { useEffect, useState } from 'react'
import { isEmpty } from 'lodash'
import {
    Autocomplete,
    Checkbox,
    Chip,
    CircularProgress,
    Grid,
    IconButton,
    Menu,
    MenuItem,
    TableCell,
    TableRow,
    TextField,
    Tooltip,
    Typography
} from '@mui/material'
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs from 'dayjs'
import type { Dayjs } from 'dayjs'
import Content from 'components/content/content'
import Filter from 'components/filter/filter'
import type { PartialFormDataProps, PartialPushNotificationProps } from 'modules/partial'
import CONSTANT from 'modules/constant'
import Notification from 'components/notification'
import GLOBAL from 'modules/global'
import type { ErrorProps } from 'modules/types'
import Icon from 'components/icon'
import MenuModalItem from 'components/menuItem/menuItem'
import GlobalStyle from 'modules/styles'
import Loading from 'components/loading/loading'
import { useDeletePushNotificationMutation, useDownloadPushNotificationListMutation, useGetPushNotificationCarModelDropdownMutation, useGetPushNotificationListMutation, useGetPushNotificationMemberTierDropdownMutation, useGetPushNotificationModelYearDropdownMutation, useGetPushNotificationTargetOptionDropdownMutation, useUpdateSchedulePushNotificationMutation } from 'store/pushNotification'
import Create from './create/create'
import Detail from './detail/detail'
import Edit from './edit/edit'

const PushNotificationList = () => {
    const [getPushNotificationList, listPushNotification] = useGetPushNotificationListMutation()
    const [_getMemberTierDropdown, _memberTierDDL] = useGetPushNotificationMemberTierDropdownMutation()
    const [_getCarModelDropdown, _carModelDDL] = useGetPushNotificationCarModelDropdownMutation()
    const [_getModelYearDropdown, _modelYearDDL] = useGetPushNotificationModelYearDropdownMutation()
    const [getTargetOptionDropdown, targetOptionDDL] = useGetPushNotificationTargetOptionDropdownMutation()
    const [downloadPushNotification, download] = useDownloadPushNotificationListMutation()
    const [deletePushotificationEvent, deletePushNotification] = useDeletePushNotificationMutation()
    const [updateScheduleEvent, updateSchedule] = useUpdateSchedulePushNotificationMutation()

    const [anchor, setAnchor] = useState<null | HTMLElement>(null)
    const [menu, setMenu] = useState<null | number>(null)
    const [dialogFilter, setDialogFilter] = useState<boolean>(false)
    const [dialogCreate, setDialogCreate] = useState<boolean>(false)
    const [dialogUpdate, setDialogUpdate] = useState<boolean>(false)
    const [drawerDetail, setDrawerDetail] = useState<boolean>(false)
    const [listChecked, setListChecked] = useState([])
    const [isChecked, setIsChecked] = useState<boolean>(false)

    const [airingTimeMax, setAiringTimeMax] = useState<Dayjs | null>(null)
    const [airingTimeMin, setAiringTimeMin] = useState<Dayjs | null>(null)
    const [scheduledAtMax, setScheduledAtMax] = useState<Dayjs | null>(null)
    const [scheduledAtMin, setScheduledAtMin] = useState<Dayjs | null>(null)

    const [randomKey, setRandomKey] = useState<number>(0)

    const [filter, setFilter] = useState<PartialPushNotificationProps>({
        carModelName: '',
        modelYear: '',
        targetOptions: '',
        member: '',
        airingMinDate: '',
        airingMaxDate: '',
        scheduledMinDate: '',
        scheduledMaxDate: '',
        search: ''
    })

    const [payload, setPayload] = useState<PartialPushNotificationProps & Omit<PartialFormDataProps, 'field' | 'search'>>({
        start: 0,
        length: CONSTANT.DEFAULT_PAGINATION_PER_PAGE,
        targetOptions: '',
        carModelName: '',
        modelYear: '',
        member: '',
        airingMinDate: '',
        airingMaxDate: '',
        scheduledMinDate: '',
        scheduledMaxDate: '',
        status: '',
        search: ''
    })

    const onSearch = (value: string) => {
        const formatedValue = value.split(',')
            .map((val: string) => val.trim())
            .join(', ')

        setPayload({ ...payload, start: 0, search: formatedValue })
    }

    const onChangePage = (value: number) => setPayload({ ...payload, start: value - 1 })
    const onChangePerPage = (value: number) => setPayload({ ...payload, start: 0, length: value })

    const onResync = () => {
        const formData = new FormData()

        formData.append('start', payload.start.toString())
        formData.append('length', payload.length.toString())

        if (!isEmpty(payload.search)) formData.append('search', payload.search ?? '')
        if (!isEmpty(payload.status) && payload.status) formData.append('status', payload.status)

        if (!isEmpty(payload.carModelName) && payload.carModelName)
            formData.append('carModelName', payload.carModelName)

        if (!isEmpty(payload.modelYear) && payload.modelYear)
            formData.append('modelYear', payload.modelYear)

        if (!isEmpty(payload.member) && payload.member)
            formData.append('member', payload.member)

        if (!isEmpty(payload.airingMinDate) && payload.airingMinDate)
            formData.append('airingMinDate', payload.airingMinDate)

        if (!isEmpty(payload.airingMaxDate) && payload.airingMaxDate)
            formData.append('airingMaxDate', payload.airingMaxDate)

        if (!isEmpty(payload.scheduledMinDate) && payload.scheduledMinDate)
            formData.append('scheduledMinDate', payload.scheduledMinDate)

        if (!isEmpty(payload.scheduledMaxDate) && payload.scheduledMaxDate)
            formData.append('scheduledMaxDate', payload.scheduledMaxDate)

        if (!isEmpty(payload.targetOptions) && payload.targetOptions)
            formData.append('targetOptions', payload.targetOptions)


        getPushNotificationList(formData)
    }

    const onDownload = (type?: string) => {
        const formData = new FormData()

        formData.append('start', String(0))
        formData.append('length', CONSTANT.DEFAULT_PAGINATION_MAXIMUM_DOWNLOAD.toString())

        if (!isEmpty(payload.search)) formData.append('search', payload.search ?? '')
        if (!isEmpty(payload.status) && payload.status) formData.append('status', payload.status)

        if (!isEmpty(payload.carModelName) && payload.carModelName)
            formData.append('carModelName', payload.carModelName)

        if (!isEmpty(payload.modelYear) && payload.modelYear)
            formData.append('modelYear', payload.modelYear)

        if (!isEmpty(payload.member) && payload.member)
            formData.append('member', payload.member)

        if (!isEmpty(payload.airingMinDate) && payload.airingMinDate)
            formData.append('airingMinDate', payload.airingMinDate)

        if (!isEmpty(payload.airingMaxDate) && payload.airingMaxDate)
            formData.append('airingMaxDate', payload.airingMaxDate)

        if (!isEmpty(payload.scheduledMinDate) && payload.scheduledMinDate)
            formData.append('scheduledMinDate', payload.scheduledMinDate)

        if (!isEmpty(payload.scheduledMaxDate) && payload.scheduledMaxDate)
            formData.append('scheduledMaxDate', payload.scheduledMaxDate)

        if (!isEmpty(payload.targetOptions) && payload.targetOptions)
            formData.append('targetOptions', payload.targetOptions)

        if (type && !isEmpty(type)) formData.append('Download-Type', type)

        downloadPushNotification(formData)
    }

    const onFilter = (state: boolean) => setDialogFilter(state)
    const onCreate = () => setDialogCreate(true)
    const onSchedule = () => {
        const data = {
            id: listChecked
        }
        updateScheduleEvent(data)
    }

    const onAction = (event: React.MouseEvent<HTMLElement>, index: null | number) => {
        setAnchor(event.currentTarget)
        setMenu(index)
    }

    const onRemoveAnchor = async (callback: CallableFunction) => {
        setAnchor(null)
        callback(callback)
    }

    const handleCheck = (event: React.ChangeEvent<HTMLInputElement>) =>
        event.target.checked
            ? setListChecked([...listChecked, Number(event.target.value)] as never)
            : setListChecked([...listChecked].filter((o) => o !== Number(event.target.value)))

    const handleCheckAll = (event: React.ChangeEvent<HTMLInputElement>) => {
        setIsChecked(!isChecked)

        return event.target.checked
            ? setListChecked([
                ...listChecked,
                ...(((listPushNotification.data &&
                    listPushNotification.data.data.filter((y) => y.status == 'Pending' && dayjs().isBefore(dayjs(y.airingTime))).map((x) => x.id)) ||
                    undefined) as never)
            ])
            : setListChecked([])
    }

    const handleChangeAiringTime = (date: Dayjs | null, type: 'min' | 'max') => {
        const newDate = (!isEmpty(date) && date.format('YYYY/MM/DD HH:mm')) || ''
        if (type == 'min') {
            setAiringTimeMin(date)
            filter.airingMinDate = newDate
        } else {
            setAiringTimeMax(date)
            filter.airingMaxDate = newDate
        }
    }

    const handleChangeScheduledAt = (date: Dayjs | null, type: 'min' | 'max') => {
        const newDate = (!isEmpty(date) && date.format('YYYY/MM/DD HH:mm')) || ''
        if (type == 'min') {
            setScheduledAtMin(date)
            filter.scheduledMinDate = newDate
        } else {
            setScheduledAtMax(date)
            filter.scheduledMaxDate = newDate
        }
    }

    const tableHeadTitles = [
        'ID',
        'Push Notification Name',
        'Airing Time',
        // 'Member Tier Target',
        // 'Car Model',
        // 'Model Year',
        'Target Option',
        'CTA Url',
        'Status',
        'Status Scheduled At',
        'Sent',
        'Created By',
        'Created At'
    ]

    const formatDate = (val: string): string => dayjs(val).format('D MMM YYYY HH:mm:ss')

    const openAnchor = Boolean(anchor)

    const totalPage = listPushNotification.data && GLOBAL.tableTotalPage(listPushNotification.data.recordsTotal)

    const numbers = GLOBAL.tableNumber(payload.start)

    const isDisableModify = (status: string, airingTime: string): boolean => {
        if (status == 'Pending' || status == 'Scheduled') {
            const targetTime = dayjs(airingTime).subtract(10, 'minute')
            const now = dayjs()

            return now.isAfter(targetTime)
        } else {
            return true
        }
    }

    const handleResetFilter = () => {
        setRandomKey(randomKey + 1)
        setAiringTimeMax(null)
        setAiringTimeMin(null)
        setScheduledAtMax(null)
        setScheduledAtMin(null)
        setFilter({
            carModelName: '',
            modelYear: '',
            member: '',
            airingMinDate: '',
            airingMaxDate: '',
            scheduledMinDate: '',
            scheduledMaxDate: '',
            targetOptions: ''
        })
        setPayload({
            ...payload,
            start: 0,
            status: '',
            carModelName: '',
            modelYear: '',
            member: '',
            airingMinDate: '',
            airingMaxDate: '',
            scheduledMinDate: '',
            scheduledMaxDate: '',
            targetOptions: ''
        })
        onFilter(false)
    }

    useEffect(() => {
        onResync()
    }, [payload])

    return (
        <>
            <Content
                title='Push Notification List'
                tableHeadTitles={tableHeadTitles}
                onSearch={onSearch}
                onResync={onResync}
                onFilter={() => onFilter(true)}
                onDownload={onDownload}
                onDownloadTypeIgnored={['pdf']}
                downloadLoading={download.isLoading}
                onUpload={onCreate}
                uploadTitle='Create New Push Notification'
                uploadPrefixIcon='Add'
                onAdditional={listChecked.length ? onSchedule : undefined}
                additionalTitle='On Schedule'
                additionalColor='success'
                additionalLoading={updateSchedule.isLoading}
                pagination={onChangePage}
                onChangePerPage={onChangePerPage}
                totalPage={totalPage}
                totalRecords={listPushNotification.data && listPushNotification.data.recordsTotal}
                page={payload.start + 1}
                isLoading={listPushNotification.isLoading}
                useDownloadDropdown
                useCheckbox
                onCheckBoxAll={(e) => handleCheckAll(e)}
                allChecked={listChecked}
            >
                {listPushNotification.isSuccess &&
                    listPushNotification.data &&
                    listPushNotification.data.data.length > 0 &&
                    listPushNotification.data.data.map((table, index) => (
                        <TableRow key={index}>
                            <TableCell>
                                <Checkbox
                                    value={`${table.id}`}
                                    onChange={(e) => handleCheck(e)}
                                    checked={listChecked.includes(Number(table.id) as never)}
                                    disabled={
                                        !(table.status == 'Pending') ||
                                        (table.status == 'Pending' && dayjs().isAfter(dayjs(table.airingTime)))
                                    }
                                />
                            </TableCell>
                            <TableCell>{numbers[index] + 1}</TableCell>
                            <TableCell>
                                <IconButton
                                    id={`button-${index}-${table.id}`}
                                    aria-haspopup='true'
                                    aria-controls={openAnchor ? `menu-${index}-${table.id}` : undefined}
                                    aria-expanded={openAnchor ? 'true' : undefined}
                                    onClick={(event) => onAction(event, index)}
                                >
                                    <Icon icon='MoreHoriz' />
                                </IconButton>
                                <Menu
                                    id={`menu-${index}-${table.id}`}
                                    aria-labelledby={`button-${index}-${table.id}`}
                                    anchorEl={anchor}
                                    open={openAnchor && menu == index}
                                    onClose={() => onRemoveAnchor(() => setMenu(null))}
                                    anchorOrigin={{
                                        vertical: 'top',
                                        horizontal: 'left'
                                    }}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'left'
                                    }}
                                >
                                    <MenuItem onClick={() => onRemoveAnchor(() => setDrawerDetail(true))}>
                                        View
                                    </MenuItem>
                                    <MenuItem
                                        onClick={() => onRemoveAnchor(() => setDialogUpdate(true))}
                                        disabled={isDisableModify(table.status, table.airingTime)}
                                    >
                                        Edit
                                    </MenuItem>
                                    <MenuModalItem
                                        title='Delete'
                                        loading={deletePushNotification.isLoading}
                                        onClick={() =>
                                            onRemoveAnchor(() =>
                                                deletePushotificationEvent({
                                                    id: table.id
                                                })
                                            )
                                        }
                                        disabled={isDisableModify(table.status, table.airingTime)}
                                    >
                                        <Typography {...GlobalStyle.ErrorTypography}>Delete</Typography>
                                    </MenuModalItem>
                                </Menu>
                                <Detail
                                    id={table.id}
                                    open={drawerDetail && menu == index}
                                    onClose={() => setDrawerDetail(false)}
                                />
                                <Edit
                                    id={table.id}
                                    open={dialogUpdate && menu == index}
                                    onClose={() => setDialogUpdate(false)}
                                    resyncList={onResync}
                                />
                            </TableCell>
                            <TableCell>{table.id}</TableCell>
                            <TableCell>{table.pushNotificationName || '-'}</TableCell>
                            <TableCell style={{ whiteSpace: 'nowrap' }}>{table.airingTime && formatDate(table.airingTime) || '-'}</TableCell>
                            {/* <TableCell>{table.memberTierTarget?.replaceAll(';', ', ') || '-'}</TableCell> */}
                            {/* <TableCell style={{ whiteSpace: 'nowrap' }}>
                                <Tooltip
                                    title={(
                                        table.carModel?.replaceAll(';', ', ').length > 42 ?
                                            table.carModel?.replaceAll(';', ', ') : ''
                                    ) || ''}
                                >
                                    <Typography
                                        noWrap
                                    >
                                        {
                                            (
                                                table.carModel?.replaceAll(';', ', ').length > 42 ?
                                                    `${table.carModel?.replaceAll(';', ', ').slice(0, 42)}...` :
                                                    table.carModel?.replaceAll(';', ', ')
                                            ) || '-'
                                        }
                                    </Typography>
                                </Tooltip>
                            </TableCell> */}
                            {/* <TableCell style={{ whiteSpace: 'nowrap' }}>
                                <Tooltip
                                    title={(
                                        table.modelYear?.replaceAll(';', ', ').length > 42 ?
                                            table.modelYear?.replaceAll(';', ', ') : ''
                                    ) || ''}
                                >
                                    <Typography
                                        noWrap
                                    >
                                        {
                                            (
                                                table.modelYear?.replaceAll(';', ', ').length > 42 ?
                                                    `${table.modelYear?.replaceAll(';', ', ').slice(0, 42)}...` :
                                                    table.modelYear?.replaceAll(';', ', ')
                                            ) || '-'
                                        }
                                    </Typography>
                                </Tooltip>
                            </TableCell> */}
                            <TableCell style={{ whiteSpace: 'nowrap' }}>{table.targetOptions}</TableCell>
                            <TableCell style={{ whiteSpace: 'nowrap' }}>
                                <Tooltip
                                    title={(
                                        (table.ctaUrl?.length ?? 0) > 42 ?
                                            table.ctaUrl : ''
                                    ) || ''}
                                >
                                    <Typography
                                        noWrap
                                    >
                                        {
                                            (
                                                (table.ctaUrl?.length ?? 0) > 42 ?
                                                    `${table.ctaUrl?.slice(0, 42)}...` :
                                                    table.ctaUrl
                                            ) || '-'
                                        }
                                    </Typography>
                                </Tooltip>
                            </TableCell>
                            <TableCell>
                                <Chip
                                    sx={table.status == 'Sending' ? {
                                        backgroundColor: '#00AAD2',
                                        color: 'white'
                                    } : {}}
                                    label={table.status == 'Pending' ? 'Draft' : table.status}
                                    color={
                                        table.status == 'Pending' ? 'warning' :
                                            table.status == 'Sent' ? 'success' :
                                                table.status == 'Failed' ? 'error' :
                                                    table.status == 'Scheduled' ? 'primary' : 'default'
                                    }
                                />
                            </TableCell>
                            <TableCell style={{ whiteSpace: 'nowrap' }}>{table.statusScheduleAt && formatDate(table.statusScheduleAt) || '-'}</TableCell>
                            <TableCell>{table.sent || '-'}</TableCell>
                            <TableCell>{table.createdBy || '-'}</TableCell>
                            <TableCell style={{ whiteSpace: 'nowrap' }}>{table.createdAt && formatDate(table.createdAt) || '-'}</TableCell>
                        </TableRow>
                    ))}
            </Content>

            {listPushNotification.isLoading && <Loading />}

            <Create open={dialogCreate} onClose={() => setDialogCreate(false)} resyncList={onResync} />

            <Filter
                open={dialogFilter}
                title='Filter'
                isSubmitDisabled={!GLOBAL.isFilterContainValue(filter)}
                onClose={() => onFilter(false)}
                onCancel={() => onFilter(false)}
                onReset={handleResetFilter}
                onSubmit={() => {
                    setPayload({ ...payload, start: 0, ...filter })
                    onFilter(false)
                }}
            >
                <Grid container columns={16}>
                    <Grid item xs={16} marginBottom={.8}>
                        <Typography variant='body1'>
                            Airing Date
                        </Typography>
                    </Grid>
                    <Grid item xs={16} container columns={16} marginTop={0} marginBottom={1} sx={{
                        justifyContent: 'space-between'
                    }}>
                        <Grid item xs={7.8}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} dateLibInstance={dayjs}>
                                <DateTimePicker
                                    value={airingTimeMin}
                                    onChange={(date: Dayjs | null) => handleChangeAiringTime(date, 'min')}
                                    label='Min Date'
                                    format='DD-MM-YYYY HH:mm'
                                    sx={{ width: '100%' }}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid item xs={7.8}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} dateLibInstance={dayjs}>
                                <DateTimePicker
                                    value={airingTimeMax}
                                    onChange={(date: Dayjs | null) => handleChangeAiringTime(date, 'max')}
                                    label='Max Date'
                                    format='DD-MM-YYYY HH:mm'
                                    sx={{ width: '100%' }}
                                />
                            </LocalizationProvider>
                        </Grid>
                    </Grid>
                    {/* <Grid item xs={16} marginTop={1} marginBottom={1}>
                        <Autocomplete
                            key={'carModelId-' + randomKey}
                            options={(carModelDDL && carModelDDL.data) || []}
                            getOptionLabel={(option) => option.name}
                            isOptionEqualToValue={(option, value) =>
                                option && value ? option.id == value.id : false
                            }
                            onOpen={() => getCarModelDropdown()}
                            onChange={(_, carModel) => {
                                setFilter({
                                    ...filter,
                                    carModelName: String((carModel && carModel.id) || '')
                                })
                            }}
                            value={
                                (carModelDDL &&
                                    carModelDDL.data &&
                                    carModelDDL.data.find((e) => String(e.id) == filter.carModelName)) ||
                                undefined
                            }
                            ListboxProps={GlobalStyle.ListBox}
                            renderOption={(props, item) => (
                                <li {...props} key={item.id}>
                                    {item.name}
                                </li>
                            )}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    name='carModelName'
                                    label='Car Model'
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {carModelDDL.isLoading && <CircularProgress color='inherit' size={20} />}
                                                {params.InputProps.endAdornment}
                                            </>
                                        )
                                    }}
                                />
                            )}
                        />
                    </Grid> */}
                    {/* <Grid item xs={16} marginTop={1} marginBottom={1}>
                        <Autocomplete
                            key={'modelYearId-' + randomKey}
                            options={(modelYearDDL && modelYearDDL.data) || []}
                            getOptionLabel={(option) => option.year.toString()}
                            isOptionEqualToValue={(option, value) =>
                                option && value ? option.year == value.year : false
                            }
                            onOpen={() => getModelYearDropdown()}
                            onChange={(_, modelYear) => {
                                setFilter({
                                    ...filter,
                                    modelYear: String((modelYear?.year) || '')
                                })
                            }}
                            value={
                                (modelYearDDL &&
                                    modelYearDDL.data &&
                                    modelYearDDL.data.find((e) => String(e.year) == filter.modelYear)) ||
                                undefined
                            }
                            ListboxProps={GlobalStyle.ListBox}
                            renderOption={(props, item) => (
                                <li {...props} key={item.year}>
                                    {item.year}
                                </li>
                            )}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    name='modelYear'
                                    label='Model Year'
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {modelYearDDL.isLoading && <CircularProgress color='inherit' size={20} />}
                                                {params.InputProps.endAdornment}
                                            </>
                                        )
                                    }}
                                />
                            )}
                        />
                    </Grid> */}
                    {/* <Grid item xs={16} marginTop={1} marginBottom={1}>
                        <Autocomplete
                            key={'memberTierId-' + randomKey}
                            options={(memberTierDDL && memberTierDDL.data) || []}
                            getOptionLabel={(option) => option.name}
                            isOptionEqualToValue={(option, value) =>
                                option && value ? option.id == value.id : false
                            }
                            onOpen={() => getMemberTierDropdown()}
                            onChange={(_, memberTier) => {
                                setFilter({
                                    ...filter,
                                    member: String((memberTier && memberTier.id) || '')
                                })
                            }}
                            value={
                                (memberTierDDL &&
                                    memberTierDDL.data &&
                                    memberTierDDL.data.find((e) => String(e.id) == filter.member)) ||
                                undefined
                            }
                            ListboxProps={GlobalStyle.ListBox}
                            renderOption={(props, item) => (
                                <li {...props} key={item.id}>
                                    {item.name}
                                </li>
                            )}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    name='member'
                                    label='Member Tier Target'
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {memberTierDDL.isLoading && <CircularProgress color='inherit' size={20} />}
                                                {params.InputProps.endAdornment}
                                            </>
                                        )
                                    }}
                                />
                            )}
                        />
                    </Grid> */}
                    <Grid item xs={16} marginTop={1} marginBottom={1}>
                        <Autocomplete
                            key={'targetOptions-' + randomKey}
                            options={(targetOptionDDL.data || [])}
                            getOptionLabel={(option) => option.targetOption}
                            isOptionEqualToValue={(option, value) =>
                                option && value ? option.targetOption == value.targetOption : false
                            }
                            onOpen={() => getTargetOptionDropdown()}
                            onChange={(_, target) => {
                                setFilter({
                                    ...filter,
                                    targetOptions: String((target && target.targetOption) || '')
                                })
                            }}
                            value={
                                (targetOptionDDL &&
                                    targetOptionDDL.data &&
                                    targetOptionDDL.data.find((e) => String(e.targetOption) == filter.targetOptions)) ||
                                undefined
                            }
                            ListboxProps={GlobalStyle.ListBox}
                            renderOption={(props, item) => (
                                <li {...props} key={item.targetOption}>
                                    {item.targetOption}
                                </li>
                            )}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    name='targetOptions'
                                    label='Target Option'
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {targetOptionDDL.isLoading && <CircularProgress color='inherit' size={20} />}
                                                {params.InputProps.endAdornment}
                                            </>
                                        )
                                    }}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={16} marginTop={1} marginBottom={.8}>
                        <Typography variant='body1'>
                            Status Scheduled At
                        </Typography>
                    </Grid>
                    <Grid item xs={16} container columns={16} marginTop={0} marginBottom={1} sx={{
                        justifyContent: 'space-between'
                    }}>
                        <Grid item xs={7.8}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} dateLibInstance={dayjs}>
                                <DateTimePicker
                                    value={scheduledAtMin}
                                    onChange={(date: Dayjs | null) => handleChangeScheduledAt(date, 'min')}
                                    label='Min Date'
                                    format='DD-MM-YYYY HH:mm'
                                    sx={{ width: '100%' }}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid item xs={7.8}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} dateLibInstance={dayjs}>
                                <DateTimePicker
                                    value={scheduledAtMax}
                                    onChange={(date: Dayjs | null) => handleChangeScheduledAt(date, 'max')}
                                    label='Max Date'
                                    format='DD-MM-YYYY HH:mm'
                                    sx={{ width: '100%' }}
                                />
                            </LocalizationProvider>
                        </Grid>
                    </Grid>
                </Grid>
            </Filter>

            <Notification
                open={!listPushNotification.isLoading && !listPushNotification.isUninitialized && !listPushNotification.isSuccess}
                onClose={() => {
                    listPushNotification.reset();
                    listPushNotification.isError ? undefined : listPushNotification.isSuccess ? onResync() : undefined
                }}
                isError={Boolean(listPushNotification.error) && listPushNotification.isError}
                message={GLOBAL.returnExceptionMessage(
                    listPushNotification.isError,
                    listPushNotification.error as ErrorProps
                )}
            />

            <Notification
                open={!download.isLoading && !download.isUninitialized}
                onClose={() => download.reset()}
                isError={Boolean(download.error) && download.isError}
                message={GLOBAL.returnExceptionMessage(download.isError, download.error as ErrorProps)}
            />

            <Notification
                open={!deletePushNotification.isLoading && !deletePushNotification.isUninitialized}
                onClose={() => {
                    deletePushNotification.reset();
                    (deletePushNotification.isError ? undefined : onResync()) 
                }}
                isError={Boolean(deletePushNotification.error) && deletePushNotification.isError}
                message={GLOBAL.returnExceptionMessage(
                    deletePushNotification.isError,
                    deletePushNotification.error as ErrorProps
                )}
            />

            <Notification
                open={!updateSchedule.isLoading && !updateSchedule.isUninitialized}
                onClose={() => {
                    updateSchedule.reset();
                    if (updateSchedule.isSuccess) {
                        setListChecked([])
                        onResync()
                    }
                }}
                isError={Boolean(updateSchedule.error) && updateSchedule.isError}
                message={GLOBAL.returnExceptionMessage(
                    updateSchedule.isError,
                    updateSchedule.error as ErrorProps
                )}
            />
        </>
    )
}

export default PushNotificationList